import React, { useState, useRef, useEffect } from "react";
import "../../../Admin/HomeAdmin/Home.css";

interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
    selectedFilter: string;
  setSelectedFilter: React.Dispatch<React.SetStateAction<string>>;
  selectedFilterDistance:any,
  setSelectedFilterDistabce:React.Dispatch<React.SetStateAction<any>>;
}

const FilterMagasin: React.FC<FilterModalProps> = ({
 isOpen,
  onClose,
  selectedFilter,
  setSelectedFilter,
  selectedFilterDistance,
  setSelectedFilterDistabce,
  
  }) => {
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 500000]);
  const [activeFilter, setActiveFilter] = useState<string>("Tous");
  const minValRef = useRef<HTMLInputElement>(null);
  const maxValRef = useRef<HTMLInputElement>(null);
  const range = useRef<HTMLDivElement>(null);

  
  // Convert to percentage for visual positioning
  const getPercent = (value: number) => Math.round((value / 500000) * 100);

  // Set width of the range to decrease from the left side
  useEffect(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(priceRange[0]);
      const maxPercent = getPercent(priceRange[1]);

      if (range.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [priceRange]);

  // Handle min and max range changes
  const handlePriceRangeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = Number(e.target.value);
    const newRange = [...priceRange] as [number, number];

    if (index === 0) {
      // Don't let min exceed max - minGap
      const minGap = 1000;
      newRange[0] = Math.min(value, priceRange[1] - minGap);
    } else {
      // Don't let max go below min + minGap
      const minGap = 1000;
      newRange[1] = Math.max(value, priceRange[0] + minGap);
    }

    setPriceRange(newRange);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: isOpen ? "flex" : "none",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "100%",
          backgroundColor: "white",
          borderRadius: "16px 16px 0 0",
          padding: "20px",
          boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
          transform: isOpen ? "translateY(0)" : "translateY(100%)",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "14px",
            borderBottom: "1px solid #eee",
            paddingBottom: "15px",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              margin: 0,
              fontFamily: "Public Sans, sans-serif",
              fontWeight: 700,
            }}
          >
            Filtres
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              padding: 0,
            }}
          >
            ×
          </button>
        </div>

        {/* Sort by section */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
            borderBottom: "1px solid #eee",
            paddingBottom: "15px",
          }}
        >
          <h3
            style={{
              fontFamily: "Public Sans, sans-serif",
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "140%",
              letterSpacing: "0%",
              color: "#1A1A1A",
              marginBottom: "13px",
              marginLeft: "-7px",
            }}
          >
            Trier par
          </h3>
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              gap: "10px",
              paddingBottom: "4px",
            }}
            className="hide-scrollbar"
          >
{["tout les produits", "article que Je n'ai pas", "Mes Produits"].map(
  (label) => (
    <button
      key={label}
      onClick={() => setSelectedFilter(label)}
      style={{
        whiteSpace: "nowrap",
        padding: "8px 16px",
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        backgroundColor: selectedFilter === label ? "#1A1A1A" : "white",
        color: selectedFilter === label ? "white" : "black",
        fontSize: "14px",
        cursor: "pointer",
        flex: "0 0 auto",
      }}
    >
      {label}
    </button>
  )
)}

          </div>
        </div>

        {/* Price filter section */}
        <h3
            style={{
              fontFamily: "Public Sans, sans-serif",
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "140%",
              letterSpacing: "0%",
              color: "#1A1A1A",
              marginBottom: "13px",
              marginLeft: "-7px",
            }}
          >
            Localisation
          </h3>
          <div className="mb-5">
            <input   
            checked={selectedFilterDistance === "par parent"}
    onChange={(e) =>
      setSelectedFilterDistabce(e.target.checked ? "par parent" : null)
    }
            style={{
      accentColor: "#1A1A1A",
      fontFamily:"lato",
    }} type="checkbox" 
    /> Activé votre position
          </div>

        {/* Apply button */}
<button
  onClick={onClose}
  style={{
    width: "100%",
    padding: "12px",
    backgroundColor: "#1A1A1A",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    marginTop: "10px",
  }}
>
  Appliquer les filtres
</button>

      </div>
    </div>
  );
};

export default FilterMagasin;
